import { render, staticRenderFns } from "./checkout-client-login.vue?vue&type=template&id=2bfe8ada"
import script from "./checkout-client-login.vue?vue&type=script&lang=ts"
export * from "./checkout-client-login.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfe8ada')) {
      api.createRecord('2bfe8ada', component.options)
    } else {
      api.reload('2bfe8ada', component.options)
    }
    module.hot.accept("./checkout-client-login.vue?vue&type=template&id=2bfe8ada", function () {
      api.rerender('2bfe8ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/checkout-client-login.vue"
export default component.exports